<template>
  <router-link :to="{name: 'commodity', params: {id: this.item.id}}">
    <div class="position-relative">
      <WatermarkImage>
        <ImageCarousel show-border :img-width="220" :img-height="220" :img_list="item.Images" :auto-play="true" style="min-height: 220px"/>
      </WatermarkImage>
      <button
          type="button"
          class="btn no-hover btn-icon-only favorite-button"
          :class="{'is-favorited': isFavorited}"
          :disabled="isTogglingFavorite"
          @click.stop.prevent="toggleFavorite"
      >
        <i :class="['fa', isFavorited ? 'fa-heart' : 'fa-heart-o']"></i>
      </button>
      <div class="row m-0" style="position: absolute; top: 0; padding: 12px; gap: 4px;">
        <TagItem v-if="isNew" :text="'最新'" :color="'yellow'" />
        <TagItem v-if="item.is_pre_order !== false"
                 :text="'預定'"
                 :color="this.$tagItemType.Red"
        />
      </div>
      <div style="margin-top: 6px"></div>
      <p class="m-0 text-custom-text font-weight-500 line-clamp-1"> {{ item.name }} </p>
      <p v-if="!isEmpty(item.final_date)" class="m-0 text-custom-remain-time font-weight-500">
        {{ daysLeft(item.final_date) < 0 ? '已結單' : '還剩 ' + timeLeft(item.final_date) }}
      </p>
      <p v-if="isEmpty(item.final_date)" class="m-0 text-custom-remain-time font-weight-500"
         style="padding-top: 27px"></p>
      <div class="row m-0 tag-list">
        <div v-for="(e, index) in visibleTags" :key="index" class="row m-0 mb-1">
          <TagItem
              :text="e.text"
              :color="e.color"
          />
          <div class="mx-sm-1" v-if="index !== visibleTags.length-1 && overflowCount === 0"></div>
        </div>
        <div v-if="overflowCount > 0" class="row m-0 mb-1">
          <TagItem :text="`+${overflowCount}`" :color="'white'"/>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import moment from 'moment';
import {timeLeft} from "@/util/formatter";
import TagItem from "@/views/components/elements/TagItem";
import ImageCarousel from "@/views/components/elements/ImageCarousel";
import WatermarkImage from "@/components/WatermarkImage.vue";
import {isEmpty, getMediaUrl} from "@/util/helpers";
import {addFavoriteCatalog, removeFavoriteCatalog} from "@/util/http_api";

export default {
  name: "CatalogItem",
  components: {
    TagItem: TagItem,
    ImageCarousel: ImageCarousel,
    WatermarkImage,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tag_list: [],
      MAX_TAGS: 6,
      localFavorited: false,
      isTogglingFavorite: false,
      //     text: "GoodSmileCompany6月新品123123123",
      //     expireTime: "2023/06/30",
      //     pictureTagItems: [
      //       {text: '預定', color: 'red'},
      //     ],
      //     tagItems: [
      //       {text: 'Good Smile Company', color: 'blue'},
      //       {text: 'PVC', color: 'green'},
      //     ]
    };
  },
  computed: {
    isNew() {
      return !!this.item.is_new;
    },
    isFavorited() {
      return this.localFavorited;
    },
    visibleTags() {
      return this.tag_list.slice(0, this.MAX_TAGS);
    },
    overflowCount() {
      return Math.max(0, this.tag_list.length - this.MAX_TAGS);
    }
  },
  watch: {
    'item.is_favorited': {
      immediate: true,
      handler(val) {
        this.localFavorited = !!val;
      },
    },
  },
  beforeMount() {
    if (typeof this.item.CommodityBrands === 'string') {
      let brands = this.item.CommodityBrands.split(",");
      for (let i = 0; i < brands.length; i++) {
        this.tag_list.push({text: brands[i], color: 'blue'});
      }
    }
    if (typeof this.item.CommodityTypes === 'string') {
      let types = this.item.CommodityTypes.split(",");
      for (let i = 0; i < types.length; i++) {
        this.tag_list.push({text: types[i], color: 'green'});
      }
    }
  },
  methods: {
    timeLeft: timeLeft,
    isEmpty: isEmpty,
    daysLeft(date) {
      return moment(date).diff(moment(), 'days');
    },
    clickAction(src) {
      console.log('CatalogItem clickAction src', src);
      if (this.$route.path === '/latest') {
        this.$router.push('/commodity')
      } else {
        this.$router.push('/latest')
      }
    },
    async toggleFavorite() {
      if (this.isTogglingFavorite || !this.item.id) return;
      this.isTogglingFavorite = true;
      const next = !this.localFavorited;
      this.localFavorited = next; // 先樂觀更新畫面
      try {
        if (next) {
          await addFavoriteCatalog(this.item.id);
        } else {
          await removeFavoriteCatalog(this.item.id);
        }
      } catch (e) {
        console.log('toggleFavorite error', e);
        this.localFavorited = !next; // 失敗則還原
      } finally {
        this.isTogglingFavorite = false;
      }
    },
  }
}
</script>

<style scoped>

.fit {
  object-fit: cover;
}

.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 8px;
}

.favorite-button {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.85);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  border: none;
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.favorite-button i {
  font-size: 16px;
  color: #a0a0a0;
}

.favorite-button.is-favorited i {
  color: #e0245e;
}

.favorite-button:hover {
  background-color: rgba(255, 255, 255, 0.95);
  transform: scale(1.08);
}

.favorite-button:disabled {
  opacity: 0.7;
}
</style>
